import { formatDate } from "@angular/common";
import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { GoogleMap } from "@angular/google-maps";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { SharedService } from "src/app/shared-modules/shared.service";
import { CustomerServiceService } from "../customer-service.service";

@Component({
  selector: "app-edit-truck-category",
  templateUrl: "./edit-truck-category.component.html",
  styleUrls: ["./edit-truck-category.component.css"],
})
export class EditTruckCategoryComponent implements OnInit {
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  mapConfigurations: any;
  inititalCoordinates: any;
  coordinatesForm!: FormGroup;
  pickupAutoComplete: any;
  pickupLat: any;
  pickupLong: any;
  dropLat: any;
  dropLong: any;
  pickup_long_name: any = "";
  pickup_short_name: any = "";
  dropAutoComplete: any;
  drop_long_name: any = "";
  drop_short_name: any = "";
  completeDropAddress: any;
  completePickUpAddress: any;
  @ViewChild("pickUpLocationSearchField")
  pickUpLocation: ElementRef | any;
  @ViewChild("dropLocationSearchField")
  dropLocation!: ElementRef;
  truckCategory: any = [];
  truckWeight: any = [];
  searchBtn: boolean = true;
  token: any;
  truckDetails: any;
  @ViewChild(GoogleMap) map: GoogleMap | any;

  constructor(
    private matdialogref: MatDialogRef<EditTruckCategoryComponent>,
    private services: CustomerServiceService,
    private fb: FormBuilder,
    private shrdSrvce: SharedService,
    private router: Router,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.today = new Date();
    this.coordinatesForm = this.fb.group({
      from_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      to_area_name: new FormControl(
        null,
        Validators.compose([Validators.required])
      ),
      date: [""],
      truck_category_name: ["", [Validators.required]],
      truck_weight: ["", [Validators.required]],
    });
    this.GetCategory();
    this.coordinatesForm.patchValue(this.data.dataKey.data[0].date);
    this.coordinatesForm.patchValue(this.data.dataKey.data[0].fromLocation);
    this.coordinatesForm.patchValue(this.data.dataKey.data[0].toLocation);
    this.coordinatesForm.patchValue(
      this.data.dataKey.truckCategory.name.truck_category_name
    );
    this.coordinatesForm.patchValue(this.data.dataKey.truckweight);
  }
  close() {
    this.matdialogref.close();
  }
  onInputPickUpchange() {
    this.geoCodePickUp(this.coordinatesForm.value.pickup);
  }

  onDropChange() {
    this.geoCodeDrop(this.coordinatesForm.value.drop);
  }

  geoCodeDrop(address: any) {
    google.maps.event.addListener(
      this.dropAutoComplete,
      "place_changed",
      () => {
        const dropPlace = this.dropAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: dropPlace.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.dropLat = results[0].geometry.location.lat();
              this.dropLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.dropLat,
                this.dropLong
              );
              geoCoder.geocode({ location: latlong }, (result: any, status) => {
                this.completeDropAddress = result[0];
                this.drop_short_name = "";
                this.drop_short_name = "";
                for (
                  let i = 0;
                  i < this.completeDropAddress.address_components.length;
                  i++
                ) {
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                      "locality" &&
                    this.completeDropAddress.address_components[i].types[1] ==
                      "political"
                  ) {
                    this.drop_short_name =
                      this.completeDropAddress.address_components[i].short_name;
                  }
                  if (
                    this.completeDropAddress.address_components[i].types[0] ==
                      "political" &&
                    this.completeDropAddress.address_components[i].types[1] ==
                      "sublocality" &&
                    this.completeDropAddress.address_components[i].types[2] ==
                      "sublocality_level_1"
                  ) {
                    this.drop_long_name =
                      this.completeDropAddress.address_components[i].long_name;
                  }
                  if (this.drop_short_name && this.drop_long_name) {
                    this.coordinatesForm.controls["drop"].setValue(
                      `${this.drop_long_name},${this.drop_short_name}`
                    );
                    break;
                  }
                }
              });
            }
          }
        );
      }
    );
  }
  geoCodePickUp(address: any) {
    google.maps.event.addListener(
      this.pickupAutoComplete,
      "place_changed",
      () => {
        const place = this.pickupAutoComplete.getPlace();
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            address: place.formatted_address,
          },
          (results: any, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              this.pickupLat = results[0].geometry.location.lat();
              this.pickupLong = results[0].geometry.location.lng();
              const latlong = new google.maps.LatLng(
                this.pickupLat,
                this.pickupLong
              );
              geoCoder.geocode({ location: latlong }, (result: any, status) => {
                this.completePickUpAddress = result[0];
                this.pickup_short_name = "";
                this.pickup_long_name = "";
                for (
                  let i = 0;
                  i < this.completePickUpAddress.address_components.length;
                  i++
                ) {
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                      "locality" &&
                    this.completePickUpAddress.address_components[i].types[1] ==
                      "political"
                  ) {
                    this.pickup_short_name =
                      this.completePickUpAddress.address_components[
                        i
                      ].short_name;
                  }
                  if (
                    this.completePickUpAddress.address_components[i].types[0] ==
                      "political" &&
                    this.completePickUpAddress.address_components[i].types[1] ==
                      "sublocality" &&
                    this.completePickUpAddress.address_components[i].types[2] ==
                      "sublocality_level_1"
                  ) {
                    this.pickup_long_name =
                      this.completePickUpAddress.address_components[
                        i
                      ].long_name;
                  }
                  if (this.pickup_short_name && this.pickup_long_name) {
                    this.coordinatesForm.controls["pickup"].setValue(
                      `${this.pickup_long_name},${this.pickup_short_name}`
                    );
                    break;
                  }
                }
              });
            }
          }
        );
      }
    );
  }

  public GetCategory() {
    this.services.GetCategory().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckCategory = response.body.data;
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }

  public GetTruckWeight() {
    var category = this.coordinatesForm.value.truck_category;
    this.services.GettruckWeight(category).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckWeight = response.body.data;
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        return;
      }
    );
  }
  ngAfterViewInit(): void {
    var options = {
      types: ["(cities)"],
      componentRestrictions: { country: "in" },
    };
    this.pickupAutoComplete = new google.maps.places.Autocomplete(
      this.pickUpLocation.nativeElement,
      options
    );
    this.dropAutoComplete = new google.maps.places.Autocomplete(
      this.dropLocation.nativeElement,
      options
    );
  }
  requestQuote() {
    this.token = sessionStorage.getItem("token");
    if (this.coordinatesForm.valid) {
      var pickDetails = this.coordinatesForm.value.pickup.split(",");
      var dropDetails = this.coordinatesForm.value.drop.split(",");
      const data = {
        fromLocation: {
          from_area_name: "Kotamitta", //pickDetails[0],
          from_city_name: "Nellore", //pickDetails[1],
          from_pincode: 524003, // this.completePickUpAddress.address_components[this.completePickUpAddress.address_components.length-1]
          from_lat: "14.4552", //this.pickupLat,
          from_long: "79.9745", //this.pickupLong
        },
        toLocation: {
          to_area_name: "VRC Centre", //dropDetails[0],
          to_city_name: "Nellore", //dropDetails[1],
          to_pincode: 524001, // this.completeDropAddress.address_components[this.completeDropAddress.address_components.length-1],
          to_lat: "14.4515", //this.dropLat,
          to_long: "79.9803", //this.dropLong
        },
        date: formatDate(this.coordinatesForm.value.date, "yyyy-MM-dd", "en"),
        truck_category: this.coordinatesForm.value.truck_category,
        truck_type: this.coordinatesForm.value.truck_type,
      };
      this.searchBtn = true;
      this.services.SearchTruckDetails(data, this.token).subscribe(
        (response: any) => {
          if (response.status === 201) {
            this.truckDetails = response.body.data;
            const searchdata = {
              data: this.truckDetails,
              truckweight: this.truckWeight.find((ele: any) => {
                return ele._id === this.coordinatesForm.value.truck_type;
              }),
              truckCategory: {
                id: this.coordinatesForm.value.truck_category,
                name: this.truckCategory.find((ele: any) => {
                  if (ele._id === this.coordinatesForm.value.truck_category) {
                    return ele.truck_category_name;
                  }
                }),
              },
            };
            this.shrdSrvce.updateSearchDetails(searchdata);

          }
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          return;
        }
      );
      this.searchBtn = false;
    }
  }
}
